import { render, staticRenderFns } from "./ReturnShipping.vue?vue&type=template&id=002daf3e&"
import script from "./ReturnShipping.vue?vue&type=script&lang=js&"
export * from "./ReturnShipping.vue?vue&type=script&lang=js&"
import style0 from "./ReturnShipping.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports